export default "__VITE_ASSET__Mgq52kNG__"